import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgCloudFlash = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-cloud-flash';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "inherit",
      fillRule: "evenodd",
      d: "M11.54 4.282a5.3 5.3 0 0 0-1.302.29c-1.758.661-3.014 2.166-3.385 4.053-.037.188-.086.348-.11.354s-.16.033-.303.059c-1.387.256-2.783 1.307-3.512 2.642-1.362 2.495-.592 5.667 1.753 7.217a5.3 5.3 0 0 0 1.811.753l.408.09h10.2l.408-.09c2.334-.517 3.978-2.399 4.215-4.826.183-1.875-.691-3.832-2.191-4.901-.6-.428-1.37-.774-1.972-.885a7 7 0 0 1-.305-.06c-.025-.007-.066-.13-.091-.274-.104-.596-.382-1.357-.673-1.842-1.061-1.767-2.941-2.746-4.951-2.58m1.34 1.579c.347.09.95.376 1.254.594.33.236.735.663.962 1.015.459.709.66 1.496.663 2.595l.001.365.73.02c.682.018.754.027 1.098.143.66.221 1.033.456 1.532.966.498.508.807 1.057 1.008 1.791.07.255.086.427.088.97.003.6-.007.695-.105 1.048-.378 1.356-1.3 2.324-2.611 2.738l-.36.114H6.86l-.36-.114c-1.352-.427-2.307-1.461-2.647-2.866-.108-.444-.098-1.463.019-1.89.257-.942.814-1.761 1.535-2.257a3.3 3.3 0 0 1 1.005-.5c.344-.116.416-.125 1.092-.143l.724-.019.025-.628c.029-.752.108-1.177.31-1.674.281-.69.821-1.359 1.417-1.754a4.1 4.1 0 0 1 1.16-.51c.154-.034.316-.072.36-.082.177-.041 1.129.012 1.38.078m-2.589 5.257a184 184 0 0 0-1.594 2.576c-.023.06.148.066 1.953.076l1.977.01-.873 1.398a55 55 0 0 0-.873 1.42c0 .023 1.249.806 1.262.791.049-.062 3.142-5.036 3.16-5.083.023-.06-.142-.066-1.953-.076l-1.977-.01.873-1.398c.481-.769.873-1.408.873-1.42-.001-.018-.476-.32-1.117-.708l-.142-.087z"
    })
  }));
});
export default SvgCloudFlash;